import type { OfflineStatusSnapshot } from "../types";
import { isBrowser } from "./supports";

export type OfflineStatusListener = (snapshot: OfflineStatusSnapshot) => void;

function createSnapshot(): OfflineStatusSnapshot {
  const isOnline = isBrowser() ? navigator.onLine : true;

  return {
    isOnline,
    isOffline: !isOnline
  };
}

export function getOfflineSnapshot(): OfflineStatusSnapshot {
  return createSnapshot();
}

export function subscribeToOfflineStatus(listener: OfflineStatusListener): () => void {
  if (!isBrowser()) {
    return () => undefined;
  }

  const handleOnline = () => listener(createSnapshot());
  const handleOffline = () => listener(createSnapshot());

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
}
